import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { alertActions } from '../../../../../../_actions/alert.actions'
import { usersService } from '../../../../../../_services/users.service'
import { Alert, Button, Col, Modal, Row, Spinner } from 'react-bootstrap'

export default function RemoveTeamMemberModal({ user, member, show, handleClose }) {
  const dispatch = useDispatch(null)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleCloseModal = () => {
    setError('')
    setLoading(false)
    setTimeout(() => {
      handleClose()
    }, 100);
  }
  
  const handleRemove = () => {
    setError('')
    setLoading(true)
    usersService.removeTeamMember(user.licensedId, member.userId)
      .then(() => {
        handleClose(true)
        dispatch(alertActions.success('Team member removed.'));
      })
      .catch(() => {
        setError('Could not remove team member at this time. Please try again.');
      })
      .then(() => {
        setLoading(false)
      })
  }

  const memberName = member ? `${member.firstName} ${member.lastName}` : null

  return (
    <Modal show={show} onHide={handleCloseModal}>
      <Modal.Header closeButton>
        <Modal.Title>Remove Team Member</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        { error && <Alert variant='danger'>{ error }</Alert> }
        <Row>
          <Col>
            <p>{`Are you sure you want to remove ${memberName} from this team member?`}</p>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Row className='w-100 justify-content-end'>
          <Col xs='7'>
            <Button disabled={loading} onClick={handleRemove} block variant='success'>
              { loading ? <Spinner size='sm' animation='border' /> : 'Yes, remove'}
            </Button>
          </Col>
          <Col xs='5'>
            <Button disabled={loading} onClick={handleCloseModal} block variant='secondary'>No, cancel</Button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  )
}
